import { useContentfulLiveUpdates } from '@contentful/live-preview/react'
import resolveResponse from 'contentful-resolve-response'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useContentAPI } from '../../../Hooks/useAPI'
import Footer from './Footer'

const MaterializedFooter = () => {
  const params = useParams()
  const paths = Object.values(params).join('/')
  const isPreviewMode = paths.includes('preview/')

  const { data } = useContentAPI('contentType', 'footerComponent', '', isPreviewMode, {
    depth: 3,
  })
  const previewData = useContentfulLiveUpdates(data)

  // remove circular references that could cause issue when trying to resolve entries using 'contentful-resolve-response'
  const jsonCollection = JSON.stringify(data)
  const parsedCollection = JSON.parse(jsonCollection)

  const footerData = isPreviewMode ? previewData?.data?.items : parsedCollection?.data?.items

  if (!footerData || footerData.length === 0) return <></>
  const resolver = {
    items: footerData,
    includes: isPreviewMode ? previewData?.data?.includes : parsedCollection?.data?.includes,
  }

  const contentData = data && data !== null ? resolveResponse(resolver)?.[0] : {}

  return <Footer content={contentData} />
}

export default MaterializedFooter
